import React, { Component } from 'react';
import * as youkuApi from 'Components/utils/youku-api';
import Image from './Image.jsx';

export class YoukuThumbnail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      thumbnailUrl: null,
    };
  }

  componentDidMount() {
    const youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
    const urlMatch = youkuRegEx.exec(this.props.imageUrl);
    if (urlMatch && urlMatch[1]) {
      youkuApi
        .getVideoThumbnailUrl(urlMatch[1])
        .then(youkuThumbnail => {
          this.setState({
            thumbnailUrl: youkuThumbnail,
          });
        })
        .catch(() => null);
    }
  }

  render() {
    const { thumbnailUrl } = this.state;
    return (
      <Image {...this.props} imageUrl={thumbnailUrl} forceImage={thumbnailUrl ? true : false} />
    );
  }
}
